import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-osa',
  templateUrl: './osa.component.html',
  styleUrls: ['./osa.component.scss']
})
export class OsaComponent implements OnInit {

  constructor() { }

  public situacaoSelecionada: number = 2;

  ngOnInit(): void {
  }

}
